package space.resolvingcode.tableNavigator

const val surveyInfoPath = "./preset/surveyInfo.json"
fun tblIDbyGroupPath(sID : String, year: String) = "./preset/$sID/$year/tIDbyGroup.json"
fun tblIDbyItemPath(sID : String, year: String) = "./preset/$sID/$year/tIDbyItem.json"
fun grpByItemPath(sID : String, year: String) = "./preset/$sID/$year/grpByItem.json"
fun grpInfoPath(sID : String, year: String) = "./preset/$sID/$year/grpInfo.json"
fun tblTitlePath(sID : String, year: String) = "./preset/$sID/$year/tblTitle.json"

var surveyInfo : dynamic = ""
var tblIDbyGroup : dynamic = ""
var tblIDbyItem : dynamic = ""
var grpByItem : dynamic = ""
var grpInfo : dynamic = ""
var tblTitles : dynamic = ""

var currentItem = ""
var currentGrp = mutableSetOf("")
